// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/chunks/28.7edb377cc0c7003e.js";
	if (chunkId === 281) return "static/chunks/281.6b285d3b1e9313d3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"307":"0ff321cfa44e3217","372":"f3284a3f4fc47c00","431":"29564a12b8cca8e4","704":"7a39f83f8b62f786","939":"163c022470a9e51a"}[chunkId] + ".js";
};